export default "__VITE_ASSET__D_7DqPKz__"